/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetRelayResponseExportUsingGETRequest {
    relayId?: number;
    serieId?: number;
    episodeId?: number;
    companyId?: number;
    search?: string;
    orderCol?: string;
    orderDir?: string;
}

/**
 * 
 */
export class RelayResponseControllerApi extends runtime.BaseAPI {

    /**
     * getRelayResponseExport
     */
    async getRelayResponseExportUsingGETRaw(requestParameters: GetRelayResponseExportUsingGETRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.relayId !== undefined) {
            queryParameters['relayId'] = requestParameters.relayId;
        }

        if (requestParameters.serieId !== undefined) {
            queryParameters['serieId'] = requestParameters.serieId;
        }

        if (requestParameters.episodeId !== undefined) {
            queryParameters['episodeId'] = requestParameters.episodeId;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.orderCol !== undefined) {
            queryParameters['orderCol'] = requestParameters.orderCol;
        }

        if (requestParameters.orderDir !== undefined) {
            queryParameters['orderDir'] = requestParameters.orderDir;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/rest-service/relay-response/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * getRelayResponseExport
     */
    async getRelayResponseExportUsingGET(requestParameters: GetRelayResponseExportUsingGETRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.getRelayResponseExportUsingGETRaw(requestParameters, initOverrides);
    }

}
